export const ADD_GLOBAL_MESSAGE = "ADD_GLOBAL_MESSAGE";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const SET_AUTH_DIALOG_VISIBILITY = "SET_AUTH_DIALOG_VISIBILITY";
